export const getRedirectPath = ({
  location,
  roles,
  adminRole,
  defaultPath = '/',
  adminPath = '/admin',
  fallbackPath,
}) => {
  const fromState = location?.state?.from;
  const statePath = fromState?.pathname
    ? `${fromState.pathname}${fromState.search || ''}${fromState.hash || ''}`
    : null;
  const search = location?.search || '';
  const fromQuery = search ? new URLSearchParams(search).get('from') : null;
  const redirectPath = statePath || fromQuery || fallbackPath;

  if (redirectPath && redirectPath !== '/login') {
    return redirectPath;
  }

  if (roles === adminRole) {
    return adminPath;
  }

  return defaultPath;
};
